import { Binding } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import {
	DataGrid,
	DataGridColumn,
	DataGridDateColumn,
	DataGridLoader,
	DataGridPagination,
	DataGridQueryFilter,
	DataGridTable,
	DataGridTextColumn,
	DataGridToolbar,
} from '@app/lib/datagrid'
import { Slots } from '@app/lib/layout'
import { Field } from '@contember/react-binding'

export default () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Newsletter submission list</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<>
						<DataGrid entities="NewsletterSubmission">
							<DataGridToolbar>
								<DataGridQueryFilter />
							</DataGridToolbar>
							<DataGridLoader>
								<DataGridTable>
									<DataGridTextColumn header="Email" field="email" />
									<DataGridTextColumn header="Medium" field="medium" />
									<DataGridTextColumn header="Source" field="source" />
									<DataGridTextColumn header="Campaign" field="campaign" />
									<DataGridDateColumn field="createdAt" header="Submitted at" />
									<DataGridColumn header="Metadata">
										<Field field="metadata" format={metadata => JSON.stringify(metadata)} />
									</DataGridColumn>
								</DataGridTable>
							</DataGridLoader>
							<DataGridPagination />
						</DataGrid>
					</>
				</div>
			</Binding>
		</>
	)
}
